<template>
  <div
    class="boxs-modal"
    v-closable="{
      exclude: ['table-content'],
      handler: 'closeUpdateModal',
    }"
  >
    <div class="box-item" @click="updateHeatMap('Assignments 100%', '#1BA5A4')">
      <div class="box" style="background: #1ba5a4"></div>
      <span>Assignments 100%</span>
    </div>

    <div
      class="box-item"
      @click="updateHeatMap('Assignments part time', '#A9CB6F')"
    >
      <div class="box" style="background: #a9cb6f"></div>
      <span>Assignments part time</span>
    </div>

    <div class="box-item" @click="updateHeatMap('Lead', '#EACE3B')">
      <div class="box" style="background: #eace3b"></div>
      <span>Lead</span>
    </div>

    <div
      class="box-item"
      @click="updateHeatMap('Assignments part time', '#D30000')"
    >
      <div class="box" style="background: #d30000"></div>
      <span>No assignments and no leads</span>
    </div>

    <div class="box-item" @click="updateHeatMap('Zero opportunity', '#7E7E7E')">
      <div class="box" style="background: #7e7e7e"></div>
      <span>Zero opportunity</span>
    </div>
    <div class="box-item" @click="updateHeatMap('Not Available', '#C4C4C4')">
      <div class="box" style="background: #c4c4c4"></div>
      <span>Not Available</span>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "login",
  components: {},
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {},
  data() {
    return {
      form: {
        id: null,
        crm_team_id: null,
        crm_department_id: null,
        type: "",
        color: "",
        month: "",
        year: "",
        status: "",
      },
    };
  },
  mounted() {
    let vm = this;
    vm.form = vm.formData;
  },
  methods: {
    closeUpdateModal() {
      eventBus.$emit("closeUpdateModal");
    },
    updateHeatMap(status, color) {
      let vm = this;
      vm.form.color = color;
      vm.form.status = status;
      if (vm.form.type == "member") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_USER", vm.form)
          .then((response) => {
            vm.$emit("saved", color);
          })
          .catch((error) => {
            console.error({ error });
          });
      } else if (vm.form.type == "team") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_TEAM", vm.form)
          .then((response) => {
            vm.$emit("saved", color);
          })
          .catch((error) => {
            console.error({ error });
          });
      } else if (vm.form.type == "department") {
        vm.$store
          .dispatch("HEATMAP_UPDATE_DEPARTMENT", vm.form)
          .then((response) => {
            vm.$emit("saved", color);
          })
          .catch((error) => {
            console.error({ error });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.boxs-modal {
  position: fixed;
  background: #fff;
  z-index: 9999999;
  border-radius: 5px;
  display: grid;
  grid-row-gap: 0px;
  box-shadow: 0px 0px 5px #000;
  @media (min-width: 300px) and (max-width: 630px) {
    left: 0% !important;
  }
  .box-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px 10px;
    &:hover {
      background: #ddd;
      border-radius: 5px;
    }
    .box {
      width: 40px;
      height: 20px;
      margin-right: 8px;
    }
    span {
      cursor: pointer;
      font-size: 12px;
    }
  }
}
</style>
